import { createSignal } from 'solid-js';

export const UNSAVED_CHANGES_KEYS = {
  loadboardStops: 'loadboardStops',
  submitBid: 'submitBid',
} as const;

export type UnsavedChangesKeyT =
  (typeof UNSAVED_CHANGES_KEYS)[keyof typeof UNSAVED_CHANGES_KEYS];

const [dirtyKeys, setDirtyKeys] = createSignal<UnsavedChangesKeyT[]>([]);

export const setUnsavedChanges = (
  key: UnsavedChangesKeyT,
  isDirty: boolean,
) => {
  setDirtyKeys((keys) => {
    const isTracked = keys.includes(key);

    if (isDirty === isTracked) {
      return keys;
    }

    return isDirty ? [...keys, key] : keys.filter((k) => k !== key);
  });
};

export const clearUnsavedChanges = () => {
  setDirtyKeys((keys) => (keys.length === 0 ? keys : []));
};

export const hasUnsavedChanges = () => dirtyKeys().length > 0;
